import { Component, OnInit, ChangeDetectorRef, NgZone, HostListener } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
import * as _moment from 'moment';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { empty } from 'rxjs';
import { AuthService, DataService } from '../../_services';

@Component({
  selector: 'app-cache-refresh',
  templateUrl: './cache-refresh.component.html',
  styleUrls: ['./cache-refresh.component.css'],
})
export class CacheRefreshComponent implements OnInit {

  public selectedMomentStart = new Date();
  public selectedMomentEnd = new Date();
  public selectedMoment = [new Date(), new Date()];


  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    public svcAuth: AuthService,
    public svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) { 
    
  }
  @HostListener('click', ['$event']) onClick(e) {
    if(e.target.classList.contains('li_cachetype')){
      this.pageData.cacheIndex = -1;
      var _title = e.target.innerHTML;
      this.pageData.cacheType.forEach((rec, iRec)=>{
        if(_title == rec.cacheType){
          this.pageData.cacheIndex = iRec
        }
      });
    }
  }
  pageData = {
    account: {     
    },
    cacheIndex: -1,
    cacheType:[],
    areas:[],
    viewMode: 'LIST',    
    autoRefresh: false
  }
  cachetype:any;
  area:any;

  ngOnInit() { 
    this.areaListLoad();
    console.log()
    this.pageData.cacheType.push({Id: '0', cacheType: 'In/Out'});
    this.pageData.cacheType.push({Id: '1', cacheType: 'Dwell-time'});
    
    setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 1000);    
    this.cachetype = this.pageData.cacheType[0].cacheType;
  }
  ngAfterViewInit(){
  }

  areaListLoad(){
    this.svcData.areaListAll().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas = res.data;
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
    });
  }

  areaSelect(arg){
    this.svcData.areaDetail(arg.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.area = res.data;
      if(arg.areaId == '0'){
        this.area.areaId = '0';
        this.area.areaName = '-- ALL --';
      }
    });
  }

  dataLoad(){
  }
  dataLoad4Occupancy(){    
  }
  Submit(){    
    //console.log(this.selectedMoment);
    var res = this.getDaysBetweenTwoDates(this.selectedMoment[0], this.selectedMoment[1]);
    //console.log(res);
    res.forEach((rec, iRec)=>{
      //console.log(rec);
      this.svcData.addDwellTime(_moment(rec).format('YYYYMMDD000000'), _moment(rec).format('YYYYMMDD235959'),this.area.areaId).subscribe(dw=> {
        if(dw.status == 'OK'){
          this.showAlert(_moment(rec).format('YYYY/MM/DD')+' is finished.');
          return;
        } 
      })
    });
  }
  showAlert(msg){
    M.toast({html: msg});
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
  } 
  cacheSelect(arg){
   this.cachetype=arg;
  }
  getDaysBetweenTwoDates(startDate, endDate) {
    const Ms_Per_Day: number = 1000 * 60 * 60 * 24;
    const start: number = startDate.getTime();
    const end: number = endDate.getTime();
    const daysBetweenDates: number = Math.ceil((end - start) / Ms_Per_Day);    
    const days: Date[] = Array.from(new Array(daysBetweenDates + 1), 
        (v, i) => new Date(start + (i * Ms_Per_Day)));
    return days;
  };
}